<template>
  <div>
    <div class="grid grid-cols-5 mb-5">
      <div class="col-span-5">
        <h1 class="text-xl font-bold text-gray-700">Orders</h1>
      </div>

      <div>
        <base-label>Start Date</base-label>
        <el-date-picker
          style="width: 90%"
          v-model="startDate"
          type="date"
          placeholder="Select a date"
          format="MM/dd/yyyy"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </div>

      <div>
        <base-label>End Date</base-label>
        <el-date-picker
          style="width: 90%"
          v-model="endDate"
          type="date"
          placeholder="Select a date"
          class="w-full"
          format="MM/dd/yyyy"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </div>
      <div>
        <base-label>Order Id</base-label>
        <base-input style="width: 90%" v-model="orderId"></base-input>
      </div>
      <div>
        <base-label>Email</base-label>
        <base-input style="width: 90%" v-model="email"></base-input>
      </div>
      <div>
        <base-button-primary @click="search" class="mt-5"
          >Search</base-button-primary
        >
      </div>
    </div>
    <div class="mb-3">
      <div class="w-full">
        <vue-good-table
          :columns="columns"
          :rows="orders"
          :search-options="{ enabled: true }"
          :sort-options="{
            enabled: true,
            initialSortBy: { field: 'email', type: 'asc' },
          }"
          :fixed-header="false"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 50,
            position: 'bottom',
            perPageDropdown: [25, 50, 100],
            dropdownAllowAll: false,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
          }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'id'">
              <base-button-white-extra-small
                title="View"
                class="mr-1 mt-1"
                @click="showDetail(props.row.id)"
              >
                <font-awesome-icon
                  icon="eye"
                  class="fa-fw nav-icon"
                ></font-awesome-icon>
              </base-button-white-extra-small>
              <base-button-primary-extra-small
                title="Change Email"
                class="mr-1 mt-1"
                @click="changeEmail(props.row)"
              >
                <font-awesome-icon
                  icon="envelope"
                  class="fa-fw nav-icon"
                ></font-awesome-icon>
              </base-button-primary-extra-small>
              <base-button-primary-extra-small
                title="Resend"
                class="mt-1"
                @click="resend(props.row)"
              >
                <font-awesome-icon
                  icon="redo"
                  class="fa-fw nav-icon"
                ></font-awesome-icon>
              </base-button-primary-extra-small>
            </span>
            <span v-else-if="props.column.field == 'total'">
              ${{ (props.row.total / 100).toFixed(2) }}
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>

    <change-order-email
      :showModal="showEmailModal"
      :emailData="emailData"
      @saved="handleSavedEmail"
      @close="showEmailModal = false"
    ></change-order-email>
  </div>
</template>

<script>
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import BaseInput from "@/components/ui/forms/BaseInput";
import BaseLabel from "../ui/forms/BaseLabel";
import BaseButtonPrimary from "../ui/buttons/BaseButtonPrimary";
import ChangeOrderEmail from "../common/ChangeOrderEmail";
export default {
  name: "Orders",
  components: {
    BaseButtonPrimary,
    BaseLabel,
    BaseInput,
    VueGoodTable,
    ChangeOrderEmail,
  },
  data() {
    return {
      orders: [],
      columns: [
        {
          label: "Email",
          field: "email",
        },
        {
          label: "Total",
          field: "total",
        },
        {
          label: "",
          field: "id",
          sortable: false,
        },
      ],
      showEmailModal: false,
      emailData: {
        id: null,
        email: null,
      },
    };
  },
  methods: {
    resend(row) {
      if (confirm("Are you sure you want to re-email this order?")) {
        this.$notify({
          title: "Order",
          message: "Resending...",
          type: "success",
        });
        this.$store.dispatch("order/resend", row.id).then((resp) => {
          if (!resp.success) return;
          this.$notify({
            title: "Order",
            message: "This order has been resent",
            type: "success",
          });
        });
      }
    },
    changeEmail(row) {
      this.emailData.id = row.id;
      this.emailData.email = row.email;
      this.showEmailModal = true;
    },
    handleSavedEmail() {
      this.handleSearch();
      this.emailData = {
        id: null,
        email: null,
      };
      this.showEmailModal = false;
    },
    showDetail(id) {
      this.$router.push("/dashboard/order-detail/" + id);
    },
    search() {
      this.$notify({
        title: "Order",
        message: "Fetching data...",
        type: "success",
      });
      const data = {
        startDate: this.startDate,
        endDate: this.endDate,
        orderId: this.orderId,
        email: this.email,
      };
      this.$store.dispatch("order/search", data).then((resp) => {
        this.orders = [];
        if (!resp.success) {
          this.$notify({
            title: "Error",
            message: "There was a problem fetching orders",
            type: "error",
          });
          return;
        }
        this.orders = resp.orders;
      });
    },
  },
  computed: {
    startDate: {
      get() {
        const ordersData = this.$store.getters["misc/getOrdersData"];
        return ordersData.startDate;
      },
      set(value) {
        this.$store.dispatch("misc/set_orders_startDate", value);
      },
    },
    endDate: {
      get() {
        const ordersData = this.$store.getters["misc/getOrdersData"];
        return ordersData.endDate;
      },
      set(value) {
        this.$store.dispatch("misc/set_orders_endDate", value);
      },
    },
    orderId: {
      get() {
        const ordersData = this.$store.getters["misc/getOrdersData"];
        return ordersData.orderId;
      },
      set(value) {
        this.$store.dispatch("misc/set_orders_orderId", value);
      },
    },
    email: {
      get() {
        const ordersData = this.$store.getters["misc/getOrdersData"];
        return ordersData.email;
      },
      set(value) {
        this.$store.dispatch("misc/set_orders_email", value);
      },
    },
  },

  mounted() {
    if (
      this.startDate.length ||
      this.endDate.length ||
      this.orderId.length ||
      this.email.length
    ) {
      this.search();
    }
  },
};
</script>

<style scoped></style>
